module.exports = __webpack_public_path__ + "static/media/p02.ce3e0d14.jpg";